import React, { useState } from "react";
import TurnosForm from "admin/turnos/TurnosForm";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import DetalleTurno from "./DetalleTurno";

function ReservarTurnoInterno() {
  const [mostrarDetalle, setMostrarDetalle] = useState(false);
  const [nroDoc, setNroDoc] = useState(false);
  const [nroTurno, setNroTurno] = useState(false);
  return (
    <Grid container>
      {!mostrarDetalle ? (
        <Grid item md={12}>
          <Box p={1}>
            <Typography variant="h5">Reserva de turnos</Typography>
            <Typography variant="h6">
              Complete el siguiente formulario
            </Typography>
          </Box>
          <TurnosForm
            turnoInterno={true}
            setMostrarDetalle={setMostrarDetalle}
            setNroDoc={setNroDoc}
            setNroTurno={setNroTurno}
          />
        </Grid>
      ) : (
        <DetalleTurno nroDoc={nroDoc} nroTurno={nroTurno} />
      )}
    </Grid>
  );
}

export default ReservarTurnoInterno;
